import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AdminPanelUserDataSectionField } from '../../../../../../../../shared/models/admin-panel-user-data-section-field';
import { AdminPanelUserOrganizationDataSectionComponent } from '../admin-panel-user-organization-data-section/admin-panel-user-organization-data-section.component';

@Component({
  selector: 'app-admin-panel-user-organization-identification-section',
  imports: [AdminPanelUserOrganizationDataSectionComponent],
  templateUrl:
    './admin-panel-user-organization-identification-section.component.html',
  styleUrl:
    './admin-panel-user-organization-identification-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserOrganizationIdentificationSectionComponent {
  fields = input.required<AdminPanelUserDataSectionField[]>();
}
